var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cart",attrs:{"id":"cart"}},[_c('Title',{attrs:{"title_id":"imgTitle-page-cart","title_text":_vm.$t('page-title.cart.title'),"subtitle_text":_vm.$t('page-title.cart.subtitle')}}),_c('Cart'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }